import { render, staticRenderFns } from "./DashSidebar.vue?vue&type=template&id=2c01f0c8&"
import script from "./DashSidebar.vue?vue&type=script&lang=js&"
export * from "./DashSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DashSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports